module.exports = "/static/assets/ff0b8beaf649d9206263afcdc403159f.png";